/**
 * Phase 16.3 — Live-Formatter für Beta-Code-Eingabe.
 *
 * Eigenes Modul, damit der Component-File `BetaLogin.tsx` ausschließlich
 * Komponenten exportiert (sonst meckert react-refresh).
 */
export function formatCodeInput(raw: string): string {
  const stripped = raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
  let body = stripped;
  if (stripped.startsWith('BETA')) body = stripped.slice(4);
  body = body.slice(0, 8);
  const segs = ['BETA'];
  if (body.length > 0) segs.push(body.slice(0, 4));
  if (body.length > 4) segs.push(body.slice(4, 8));
  return segs.join('-');
}
